import NiceSelect from "nice-select2/src/js/nice-select2";

export default function initSelect() {
  document.querySelectorAll("[data-select]").forEach(select => {
    new NiceSelect(select, {searchable: false});
  });

  document.querySelectorAll('.searchandfilter').forEach(holder => {
    const niceSelects = [];

    holder.querySelectorAll('select').forEach(select => {
      niceSelects.push(new NiceSelect(select, {searchable: false}));
    });

    function resetNiceSelect() {
      niceSelects.forEach(niceSelect => {
        let select = niceSelect.el;
        niceSelect.destroy();
        niceSelects.splice(niceSelects.indexOf(niceSelect), 1);
        niceSelects.push(new NiceSelect(select, {searchable: false}));
      });
    }

    holder.querySelector('.search-filter-reset').addEventListener('click', resetNiceSelect);
  });
}
